@import "../../../../../../../shared/styles/base";

.CopyableText {
  background: $ds-neutral-50;
  display: flex;
  padding: 0.5em 0.5em 0.5em 0.75em;
  border-radius: 0.25em;
  margin: 0.25rem 0 0;
  align-items: center;

  .text {
    font-weight: 500;
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
